import { AppLayout } from "../shared";
import AddAdvertisement from "../Advertisement/add_advertisement";

const Add_Advertisement_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <AddAdvertisement props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default Add_Advertisement_layout;
